module.exports = __webpack_public_path__ + "static/media/gallerium.d8d70c93.jpg";